import * as Immutable from 'immutable';

// from https://github.com/facebook/immutable-js/wiki/Converting-from-JS-objects
export function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null
    ? js
    : Array.isArray(js)
      ? Immutable.Seq(js).map(fromJSOrdered).toList()
      : Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
}
